import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import WorkInGolfPage from './workingolf'
import workInGolfFragment from './workingolf.fragment'

const QUERY = gql`
query WorkInGolfData($preview: Boolean) {
  workInGolfCollection(limit: 1, preview: $preview) {
    items {
      ${workInGolfFragment}
    }
  }
}
`

export { QUERY as WORKINGOLF_QUERY }

export default function WorkInGolfWithData(props) {
  const { ssrData, ...restProps } = props

  // If SSR data is provided, render directly
  if (ssrData !== undefined) {
    return ssrData ? (
      <WorkInGolfPage {...restProps} {...ssrData} />
    ) : <Error statusCode={404} />
  }

  // Fallback to client-side fetching
  return (
    <Query query={QUERY}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data && data.workInGolfCollection
        && data.workInGolfCollection.items
        && data.workInGolfCollection.items[0]

        return response ? (
          <WorkInGolfPage {...restProps} {...response} />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

WorkInGolfWithData.propTypes = {
  ssrData: PropTypes.object,
}
